<template>
  <div class="or_box">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
        <div class="dateSelect" style="margin-left: 30px">
          <div class="eventSelectNav">
            <div
              class="eventType"
              v-for="(event, index) in list"
              :key="index"
              v-bind:class="{ selected: isActive == index }"
              @click="checkItem(event, index)"
            >
              {{ event.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="top-right">
        <!-- <el-button type="text" @click="dropDownScreen">
          <img style="margin-right:20px" src="../../assets/employee/images/screen.png" />
        </el-button> -->
        <el-button
          type="text"
          @click="dropDownScreen"
          style="margin-right: 20px"
        >
          <img src="../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
      </div>
      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen == 1">
        <div class="inputs">
          <div class="formScreenInput" v-if="isActive == 0">
            <div>服务中心</div>
            <el-select
              v-model="infoQuery.strsrvcent"
              clearable
              slot="prepend"
              placeholder="请选择"
              filterable
              @change="serviceChange"
            >
              <el-option
                v-for="(item, index) in serviceList"
                :key="index"
                :label="item.StrSrvCent"
                :value="item.StrSrvCent"
              ></el-option>
            </el-select>
          </div>
          <div class="formScreenInput" v-if="isActive == 0">
            <div>项目名称</div>
            <el-input
              size="small"
              v-model="infoQuery.strobjname"
              placeholder="请输入项目名称"
            ></el-input>
          </div>
          <div class="formScreenInput" v-if="isActive != 0">
            <div>项目名称</div>
            <el-input
              size="small"
              v-model="expQuery.custname"
              placeholder="请输入项目名称"
            ></el-input>
          </div>
          <div class="formScreenInput" v-if="isActive == 0">
            <div>负责客服</div>
            <el-input
              size="small"
              v-model="infoQuery.strusername"
              placeholder="请输入负责客服"
            ></el-input>
          </div>
          <div class="timeip formScreenInput">
            <div>操作时间</div>
            <el-date-picker
              style="width: 300px !important"
              v-model="infoQuery.impdate"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right: 10px" @click="resetHandle">
            清空
          </button>
          <button class="search" @click="searchHandle">搜索</button>
          <button class="clear" @click="showDropScreen = -1">关闭</button>
        </div>
      </div>
    </div>
    <importRecord
      :toPermissionLists="permissionLists"
      v-if="
        showPage == 0 &&
        checkPermission(['customerList_import'], permissionLists)
      "
      ref="importRecord"
    ></importRecord>
    <exportRecord
      :toPermissionLists="permissionLists"
      v-if="
        showPage != 0 &&
        checkPermission(['customerList_export'], permissionLists)
      "
      :custname="custname"
      :qStstus="qStstus"
      ref="exportRecord"
    ></exportRecord>
  </div>
</template>

<script>
import xz from "../../common";
import importRecord from "./importRecord";
import exportRecord from "./exportRecord";
import checkPermission from "@/utils/permission"; // 权限判断函数
export default {
  components: {
    importRecord,
    exportRecord,
  },
  name: "HelloWorld",
  data() {
    return {
      //文件是否已上传
      isFileSuccess: false,
      custname: "",
      //根据qStstus值查看导出列表还是最后一条导出记录
      qStstus: "",
      opType: "import",
      isActive: 0,
      list: [],
      showPage: 0,
      select: "",
      ss: "",
      //下拉筛选
      showDropScreen: -1,
      //服务中心
      strsrvcent: "",
      //业务立项部门
      strobjinstname: "",
      //项目名称
      objname: "",
      //负责客服
      strusername: "",
      //时间范围
      impdate: [],
      //开始时间
      startDate: "",
      //结束时间
      endDate: "",
      //下拉服务中心列表
      serviceList: [],
      //下拉业务立项部门
      apartmentList: [],
      infoQuery: {
        pagecount: 10,
        currpage: 1,
        excelname: "",
        tableid: "XZ_emp_UserBase",
        strsrvcent: "",
        datestart: "",
        dateend: "",
        strobjname: "",
        strobjinstname: "",
        strusername: "",
        impdate: "",
      },
      expQuery: {
        pagecount: 10,
        currpage: 1,
        tableid: "XZ_emp_UserBase,XZ_emp_UserBasenewout",
        custname: "",
        datestart: "",
        dateend: "",
        impdate: "",
      },
      // 按钮权限参数
      butQuery: {
        path: "/customerList",
        powerEnName: "projectManage",
      },
      permissionLists: [], //按钮权限列表
    };
  },
  created() {
    this.getButtonPower();
    if (window.localStorage.getItem("page")) {
      this.infoQuery.pagecount = window.localStorage.getItem("page");
    }
    let q = this.$route.query;
    // console.log('q',q)
    if (q.isActive) {
      this.showPage = 1;
      this.isActive = q.isActive;
      this.showPage = q.showPage;
      this.custname = q.custname;
      this.qStstus = q.qStstus;
    }
    this.getServiceList();
    this.getApartmentList();
  },
  methods: {
    checkPermission,
    // 获取按钮权限
    getButtonPower() {
      let that = this;
      xz.getbtnPowerIdBypage(this.butQuery).then((res) => {
        // console.log('按钮',res)
        if (res.status == "ok") {
          let resmsg = res.msg;
          if (!this.isNull(resmsg)) {
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
            if (
              that.checkPermission(
                ["customerList_export"],
                that.permissionLists
              ) &&
              !that.checkPermission(
                ["customerList_import"],
                that.permissionLists
              )
            ) {
              //只有导出记录权限
              that.list = [
                {
                  name: "导出记录",
                  value: "export",
                },
              ];
              this.opType = 'export';
              this.showPage = 1
            } else if (
              !that.checkPermission(
                ["customerList_export"],
                that.permissionLists
              ) &&
              that.checkPermission(
                ["customerList_import"],
                that.permissionLists
              )
            ) {
              //只有导入记录权限
              that.list = [
                {
                  name: "导入记录",
                  value: "import",
                },
              ];
              this.opType = 'import';
              this.showPage = 0
            } else if (
              that.checkPermission(
                ["customerList_import"],
                that.permissionLists
              ) &&
              that.checkPermission(
                ["customerList_export"],
                that.permissionLists
              )
            ) {
              //都有记录权限
              that.list = [
                {
                  name: "导入记录",
                  value: "import",
                },
                {
                  name: "导出记录",
                  value: "export",
                },
              ];
            }
          } else {
            that.permissionLists = [];
            that.list = [];
          }
        } else {
          that.permissionLists = [];
          that.list = [];
        }
      });
    },
    //搜索
    searchHandle() {
      if (
        this.infoQuery.impdate === undefined ||
        this.infoQuery.impdate === null
      ) {
        this.infoQuery.impdate = [];
        this.infoQuery.datestart = "";
        this.infoQuery.dateend = "";
        this.expQuery.impdate = [];
        this.expQuery.datestart = "";
        this.expQuery.dateend = "";
      }
      if (this.infoQuery.impdate.length > 0) {
        this.infoQuery.datestart = this.infoQuery.impdate[0];
        this.infoQuery.dateend = this.infoQuery.impdate[1];
        this.expQuery.impdate = this.infoQuery.impdate;
        this.expQuery.datestart = this.infoQuery.impdate[0];
        this.expQuery.dateend = this.infoQuery.impdate[1];
      }
      if (this.showPage == 0) {
        // console.log('infoQuery',this.infoQuery)
        this.infoQuery.currpage = 1;
        this.$refs.importRecord.getOpeRecord(this.infoQuery);
      } else {
        // console.log('exportRecord',this.infoQuery)
        this.expQuery.currpage = 1;
        this.$refs.exportRecord.getExportRecord(this.expQuery);
      }
      this.showDropScreen = -1;
    },
    //判断是否为空(包含0)
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0 ||
        o == "NaN"
      );
    },
    //清空
    resetHandle() {
      this.infoQuery = {
        pagecount: 10,
        currpage: 1,
        excelname: "",
        tableid: "XZ_emp_UserBase",
        instname: "",
        impdatestart: "",
        impdateend: "",
        objname: "",
        strobjinstname: "",
        strusername: "",
        impdate: "",
      };
      this.expQuery = {
        pagecount: 10,
        currpage: 1,
        tableid: "XZ_emp_UserBase",
        custname: "",
        datestart: "",
        dateend: "",
      };
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    //下拉服务中心列表
    getServiceList() {
      xz.getsrarchinstlist().then((res) => {
        // console.log("getServeList", res);
        let dataList = [];
        for (let index = 0; index < res.length; index++) {
          const service = res[index];
          dataList.push({ StrSrvCent: service.Strinstname });
        }
        // console.log("getServeList", dataList);
        this.serviceList = dataList;
      });
    },
    serviceChange() {
      this.getApartmentList(this.infoQuery.strsrvcent, "");
    },
    //下拉立项部门
    getApartmentList(strsrvcent, strobjname) {
      xz.getsrarchinstobjinstlist(strsrvcent, strobjname).then((res) => {
        // console.log("getApartmentList", res);
        let dataList = [];
        for (let index = 0; index < res.length; index++) {
          const apartmentData = res[index];
          dataList.push({ StrObjInstName: apartmentData.StrObjInstName });
        }
        // console.log("getServeList", dataList);
        this.apartmentList = dataList;
      });
    },
    //切换
    checkItem(event, index) {
      this.isActive = index;
      this.opType = event.value;
      this.opType == "import" ? (this.showPage = 0) : (this.showPage = 1);
    },
  },
};
</script>

<style scoped>
.top-right .el-button--text {
  padding: 7px 10px;
  border: solid 1px #19bd92;
  font-size: 12px;
  color: #19bd92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--text img {
  vertical-align: sub;
}
</style>
<style>
.or_box .el-table .el-table__cell {
  padding: 6px 0;
}
.timeip .el-date-editor .el-range-separator {
  line-height: 24px;
}
.operationRecordTable .el-table td {
  padding: 5px 0;
}
.operationRecordTable .el-table th {
  padding: 10px 0;
}
.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}

.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.timeip .el-input__icon {
  margin-top: 3px !important;
  height: 32px;
  line-height: 32px;
}
.timeip .el-date-editor .el-range__icon {
  margin-top: 0px !important;
}
</style>
